/**
 * /ai/proposals — Agent-Proposed Updates inbox (Pack 18 v2).
 *
 * All 4 agents observe patterns and propose config updates. HR
 * reviews via this inbox. Mutaba'aa vetoes any proposal that would
 * relax a statutory floor.
 */

import { PageHeader } from "../components/ui";
import { AgentBadge } from "../components/ui/AgentBadge";

const EXAMPLE_PROPOSALS = [
  {
    agent: "tashghil" as const,
    title: "Raise auto-approve leave threshold to 5 days",
    rationale: "Past 90 days: 47 of 50 ≤5-day requests approved by manager without comment.",
    cited: null,
  },
  {
    agent: "rawatib" as const,
    title: "Switch payroll close to 22nd (from 25th)",
    rationale: "WPS bank submission lag pattern indicates 22nd-close has 96% on-time delivery vs 87% for 25th-close.",
    cited: null,
  },
  {
    agent: "mutabaa" as const,
    title: "Add 3-day grace to Article 88 settlement timing",
    rationale: "VETOED by Mutaba'aa — Article 88 is a statutory floor. Cannot be relaxed regardless of operational convenience.",
    cited: "Article 88",
  },
  {
    agent: "khidmat" as const,
    title: "Add 'My Iqama Expiry' as a quick-action chip",
    rationale: "Past 30 days: 142 employees asked Khidmat for their iqama expiry; the question is in the top 5.",
    cited: null,
  },
];

export function AgentProposalsPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Agent Proposals"
        subtitle="All 4 agents propose config updates based on observed patterns. HR reviews. Mutaba'aa vetoes statutory-floor relaxations."
      />
      <div className="space-y-3">
        {EXAMPLE_PROPOSALS.map((p, i) => (
          <div
            key={i}
            className={`p-4 border rounded-lg ${
              p.cited
                ? "border-rose-300 bg-rose-50/50"
                : "border-border-default bg-surface-default"
            }`}
          >
            <div className="flex items-center gap-2 mb-2">
              <AgentBadge agent={p.agent} />
              <span className="font-medium text-sm">{p.title}</span>
              {p.cited && (
                <span className="text-xs px-2 py-0.5 bg-rose-100 text-rose-800 rounded">
                  VETO · {p.cited}
                </span>
              )}
            </div>
            <p className="text-xs text-text-secondary">{p.rationale}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
